import { Component, computed, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatCheckbox } from '@angular/material/checkbox';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { SortPipe } from '@core';
import { BottomSheetMobileHeaderComponent } from '@ui';

import { FiltersStore } from '../../../stores';

@Component({
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    MatCheckbox,
    BottomSheetMobileHeaderComponent,
    SortPipe,
  ],
  selector: 'avs-li-devices-filters-sheet',
  standalone: true,
  templateUrl: './devices-filters-sheet.component.html',
})
export class DevicesFiltersSheetComponent {
  protected bottomSheetRef = inject(MatBottomSheetRef);
  protected data = inject<{
    showLocationFilter: boolean;
    tableId: string;
  }>(MAT_BOTTOM_SHEET_DATA);
  protected filtersStore = inject(FiltersStore);
  protected hasSelectedFilters = computed(() =>
    this.data.showLocationFilter
      ? this.filtersStore.hasSelectedFilters()
      : this.filtersStore.deviceMaker().length || this.filtersStore.deviceType().length,
  );
  protected selectedFloorName = computed(() => this.filtersStore.floorOptions()
    .find(floor => floor.value === this.filtersStore.floor())?.title,
  );
  protected selectedLocationName = computed(() => this.filtersStore.locationOptions()
    .find(location => location.value === this.filtersStore.building())?.title,
  );
  protected selectedRoomName = computed(() => this.filtersStore.roomOptions()
    .find(room => room.value === this.filtersStore.room())?.title,
  );
}
